<template>
  <div class="container bb_huicai_global_style">
    <div class="head">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="header__fixed__center">
            <h1>开通会员成功</h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div>
    <div class="bb_buycardvip_bg">
      <div class="bb_buycardvip_bg_card">
        <div class="bb_buycardvip_bg_card_newCardStyle">
          <img v-if="vipcardinfo.thumb==null||vipcardinfo.thumb==''" src="../../assets/images/base/fixedCard.png" />
          <img v-else :src="vipcardinfo.thumb" />
          <div class="bb_buycardvip_bg_card_newCardStyle_con">
            <div class="bb_bcd_title">
              &nbsp;
            </div>
            <div class="bb_bcd_cont1">
              {{vipcardinfo.msg_1}}
            </div>
            <div class="bb_bcd_cont2">
              {{vipcardinfo.start_date}} - {{vipcardinfo.end_date}}
            </div>
          </div>
        </div>
        <div class="bb_buycardvip_bg_tip">
          您已成功开通斐燃会员，恭喜您加入斐燃会员俱乐部
          <!-- 恭喜您加入斐燃会员俱乐部，您已成功开通{{vipcardinfo.name}}会员资格 -->
        </div>

        <div class="bb_buycardvip_bg_btn">
          <div class="bb_buycardvip_bg_btn_left" @click="stp_btn_ordevip()">查看会员</div>
          <div class="bb_buycardvip_bg_btn_right" @click="toreserve()">立即预约</div>
          <div class="clearboth"></div>
        </div>
      </div>
    </div>
    <!-- 遮罩层 -->
    <van-overlay v-if="false" :show="ishavecoupon">
      <div class="bb_buycard_overaly">
        <div class="bb_buycard_overaly_butn" v-show="coulb">
          <img class="bb_buycard_overaly_butn_bf" src="../../assets/images/base/ongbao.png">
          <img class="bb_buycard_overaly_butn_close" @click="close_mask_buycardVip()" src="../../assets/images/base/close_white.png" />
          <div class="bb_buycard_overaly_butn_open" @click="tomycoupon()">
            <img class="bb_buycard_overaly_butn_open_img" src="../../assets/images/base/hongbao31.png" />
          </div>
          <div class="bb_buycard_overaly_butn_open_txt"@click="tomycoupon()">拆开</div>
        </div>
        <div class="bb_buycard_overaly_couponlist" v-show="couli">
          <div class="bb_buycard_overaly_couponlist_close">
            <img src="../../assets/images/base/close_white.png" @click="closemask()" />
          </div>
          <div class="bb_buycard_overaly_couponlist_head">
            <img src="../../assets/images/base/hongbao34.png">
          </div>
          <div class="bb_buycard_overaly_couponlist_list">
            <img class="bb_buycard_overaly_couponlist_list_bg" src="../../assets/images/base/coupon_pop_bg.png">
            <div class="bb_buycard_overaly_couponlist_panle">
              <div class="bb_buycard_overaly_couponlist_panle_title">恭喜获得{{islistcoupon_total}}元优惠券</div>
              <div class="bb_buycard_overaly_couponlist_panle_list">
                <div v-for="(item,index) in islistcoupon" :key="index" class="bb_buycard_overaly_couponlist_panle_list_item">
                  <div class="bb_buycard_overaly_couponlist_panle_list_item_left">
                    <span>¥</span>
                    {{item.amount}}
                  </div>
                  <div class="bb_buycard_overaly_couponlist_panle_list_item_right">
                    <div class="bb_buycard_overaly_couponlist_panle_list_item_right_title">{{item.name}}</div>
                    <div class="bb_buycard_overaly_couponlist_panle_list_item_right_time">有效期：{{item.endtime}}</div>
                  </div>
                  <div class="clearboth"></div>
                  <div class="bb_buycard_overaly_couponlist_panle_list_item_num">{{(couponsalllength/2)}}张</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-overlay>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        vipcardinfo:{},
        ishavecoupon:false,
        islistcoupon:[],
        couli:false,
        coulb:true,
        card_id:'',
        islistcoupon_total:0,
        couponsalllength:0
      }
    },
    created() { },
    activated() {
      // // console.log(this.$route.params.order_no)
      this.detailByOrderNo(this.$route.params.order_no)
      // this.checkCouponReceive(this.$route.params.order_no)
    },
    watch: {},
    mounted() { },
    methods: {
      closemask(){
        this.ishavecoupon=false
      },
      close_mask_buycardVip(){
        this.ishavecoupon=false
      },
      tomycoupon(){
        this.couli=true
        this.coulb=false
      },
      checkCouponReceive(order_no){
        var $this=this
        let param = {
          order_no:order_no,
          token: localStorage.getItem("token")
        }
        var qs = require('qs');
        let url = this.api.userApi.checkCouponReceive
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // // // console.log(result)
          if (result.code == 0) {
            if(result.data.coupons.length>0){
              $this.ishavecoupon=true
              var arrtemp=[]
              $this.couponsalllength=result.data.coupons.length
              for (var i = 0; i < result.data.coupons.length; i++) {
                result.data.coupons[i].info.endtime=(result.data.coupons[i].end_date).replace(/-/g,".")
                arrtemp.push(result.data.coupons[i].info)
                $this.islistcoupon_total=parseInt($this.islistcoupon_total,10)+parseInt(result.data.coupons[i].info.amount,10)
              }
              for (var i = 0; i < arrtemp.length; i++) {
                for (var j =i+1; j< arrtemp.length; j++) {
                  if(arrtemp[i].type==arrtemp[j].type){
                    arrtemp.splice(j,1)
                    j--
                  }
                }
              }
              $this.islistcoupon=arrtemp
            }
          }
        }).catch((error) => {
          // // console.warn(error)
          // $this.$toast('error');
        })
      },
      detailByOrderNo(order_no){
        var $this=this
        let param = {
          token:localStorage.getItem("token"),
          order_no:order_no
        }
        var qs = require('qs');
        // newcardsOrderDetail
        // let url = this.api.userApi.detailByOrderNo
        let url = this.api.userApi.flCardsOrderDetailV2
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // console.log(result)
          if (result.code == 0) {
            $this.vipcardinfo=result.data
            $this.vipcardinfo.start_date=($this.vipcardinfo.start_date).replace(/\-/g,".")
            $this.vipcardinfo.end_date=($this.vipcardinfo.end_date).replace(/\-/g,".")

            $this.card_id=result.data.id
          }
        }).catch((error) => {
          // console.warn(error)
          // $this.$toast('error');
        })
      },
      stp_btn_ordevip(){
        this.$router.push({
          name: 'vip',

        })
      },
      toreserve(){
        this.$router.push({
          name: "reserve"
        })
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .bb_huicai_global_style{
    width: 100%;
    height: 100vh;
    overflow: hidden;
    overflow-y: auto;
    // background: #FFFFFF;
  }
  .bb_buycardvip_bg{
    position: absolute;
    top: 0;
    left: 0;
    width: calc(100% - 64*@vm_base);
    height: 564*@vm_base;
    margin-left: 32*@vm_base;
    margin-top: 250*@vm_base;
    background:rgba(255,255,255,1);
    box-shadow:0px 10*@vm_base 20*@vm_base 0px rgba(238,238,238,1);
    border-radius:12*@vm_base;
    .bb_buycardvip_bg_card{
      position: absolute;
      top: 0;
      left: 0;
      padding: 0 32*@vm_base;
      margin-top: -120*@vm_base;
      .bb_buycardvip_bg_card_newCardStyle{
        width: 100%;
        position: relative;
        img{
          width: 100%;
        }
        .bb_buycardvip_bg_card_newCardStyle_con{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          padding: 32*@vm_base 34*@vm_base;
          color: #FFFFFF;
          // border: 1px solid red;
          .bb_bcd_title{
            font-size: 42*@vm_base;
            font-weight: 600;
            height: 86*@vm_base;
            line-height: 86*@vm_base;
            div{
              height: 86*@vm_base;
              line-height: 86*@vm_base;
              float: right;
              font-size: 28*@vm_base;
            }
          }
          .bb_bcd_cont1{
            margin-top: 108*@vm_base;
            height: 56*@vm_base;
            line-height: 56*@vm_base;
            font-size: 28*@vm_base;
            font-weight: 400;
            color:rgba(255,255,255,0.5);
            div{
              height: 40*@vm_base;
              line-height: 40*@vm_base;
              float: right;
              font-size: 28*@vm_base;
            }
          }
          .bb_bcd_cont2{
            // border: 1px solid red;
            // height: 56*@vm_base;
            // line-height: 56*@vm_base;
            font-size: 28*@vm_base;
            font-weight: 400;
            color:rgba(255,255,255,0.5);
            div{
              // height: 40*@vm_base;
              // line-height: 40*@vm_base;
              float: right;
              font-size: 28*@vm_base;
            }
          }
        }
      }
      .bb_buycardvip_bg_tip{
        padding: 48*@vm_base 0*@vm_base 60*@vm_base 0*@vm_base;
        color: #444054;
        font-size:32*@vm_base;
        font-weight:500;
        color:rgba(68,64,84,1);
        line-height:48*@vm_base;
      }
      .bb_buycardvip_bg_btn{
        width: 100%;
        .bb_buycardvip_bg_btn_left{
          width:300*@vm_base;
          padding: 22*@vm_base;
          // height:80*@vm_base;
          // line-height: 80*@vm_base;
          background:rgba(68,64,84,1);
          border-radius:12*@vm_base;
          color: #FFFFFF;
          font-size:32*@vm_base;
          text-align: center;
          font-weight:500;
          float: left;
        }
        .bb_buycardvip_bg_btn_right{
          width:300*@vm_base;
          padding: 22*@vm_base;
          // height:80*@vm_base;
          // line-height: 80*@vm_base;
          background:rgba(242,242,242,1);
          border-radius:12*@vm_base;
          font-size:32*@vm_base;
          font-weight:500;
          text-align: center;
          color:rgba(68,64,84,1);
          float: right;
        }
      }
    }

  }
  .bb_buycard_overaly{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .bb_buycard_overaly_butn{
      width: 100%;
      padding: 0 81*@vm_base;
      position: relative;
      .bb_buycard_overaly_butn_bf{
        width: 100%;
        margin-left: 13.245*@vm_base;
      }
      .bb_buycard_overaly_butn_close{
        width: 60*@vm_base;
        margin: 0 auto;
        margin-top: -13.64*@vm_base;
      }
      .bb_buycard_overaly_butn_open{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        margin-bottom: 216.36*@vm_base;
        .bb_buycard_overaly_butn_open_img{
          width: 178*@vm_base;
          margin: 0 auto;
        }
      }
      .bb_buycard_overaly_butn_open_txt{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        margin-bottom: 216.36*@vm_base;
        height:178*@vm_base;
        line-height: 178*@vm_base;
        text-align: center;font-size: 44*@vm_base;
        color: #FFFFFF;
      }
    }
    .bb_buycard_overaly_couponlist{
      width: 100%;
      padding: 0 85*@vm_base;
      .bb_buycard_overaly_couponlist_close{
        width: 100%;
        height: 60*@vm_base;
        margin-bottom: 32*@vm_base;
        img{
          float: right;
          width: 60*@vm_base;
        }
      }
      .bb_buycard_overaly_couponlist_head{
        width: 100%;
        img{
          width: 70%;
          margin-left: 15%;
        }
      }
      .bb_buycard_overaly_couponlist_list{
        width: 100%;
        position: relative;
        .bb_buycard_overaly_couponlist_list_bg{
          width: 100%;
        }
        .bb_buycard_overaly_couponlist_panle{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          padding: 11*@vm_base 27*@vm_base 0 27*@vm_base;
          .bb_buycard_overaly_couponlist_panle_title{
            width: 100%;
            height: 106*@vm_base;
            line-height: 106*@vm_base;
            text-align: center;
            color: #FFFFFF;
            font-size: 40*@vm_base;
          }
          .bb_buycard_overaly_couponlist_panle_list{
            width: 100%;
            height: 318*@vm_base;
            overflow: hidden;
            // overflow-y: auto;
            .bb_buycard_overaly_couponlist_panle_list_item{
              width: 100%;
              height: 150*@vm_base;
              background-image: url(../../assets/images/base/asd.png);
              background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
              margin-bottom: 9*@vm_base;
              position: relative;
              .bb_buycard_overaly_couponlist_panle_list_item_num{
                position: absolute;
                top: 0;
                right: 0;
                width:80*@vm_base;
                height:32*@vm_base;
                line-height: 32*@vm_base;
                background:rgba(255,244,244,1);
                border-radius:0px 10*@vm_base 0px 10*@vm_base;
                text-align: center;
                font-size:22*@vm_base;
                font-weight:500;
                color:rgba(243,163,128,1);
              }
              .bb_buycard_overaly_couponlist_panle_list_item_left{
                width: 35%;
                height: 150*@vm_base;
                float: left;
                line-height: 150*@vm_base;
                text-align: center;
                font-weight: 600;
                color: #A25138;
                font-size: 72*@vm_base;
                position: relative;
                span{
                  font-size: 32*@vm_base;
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  height: 36*@vm_base;
                  line-height: 36*@vm_base;
                  margin-bottom: 42*@vm_base;
                  margin-left: 30*@vm_base;
                }
              }
              .bb_buycard_overaly_couponlist_panle_list_item_right{
                width: 65%;
                height: 150*@vm_base;
                float: left;
                padding: 32*@vm_base;
                .bb_buycard_overaly_couponlist_panle_list_item_right_title{
                  height: 43*@vm_base;
                  line-height: 43*@vm_base;
                  color: #666666;
                  font-size: 28*@vm_base;
                  font-weight: 500;
                }
                .bb_buycard_overaly_couponlist_panle_list_item_right_time{
                  height: 43*@vm_base;
                  line-height: 43*@vm_base;
                  color: #999999;
                  font-size: 22*@vm_base;
                  font-weight: 400;
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/vip/vipsuccess.vue